<div>
  <div class="container">
    <p>
      <b>Introduction</b>
    </p>
    @if (cService.tokenDtls.firstTimeVerification=='True' || cService.isFromHeadIcon==true) {
      <p>
        The Ohio Department of Education may need to contact you or send you important updates and alerts to provide you with quality customer service.  Please take a few moments to verify and update your contact information.
      </p>
    }
    @if (cService.tokenDtls.emailUpdated=='True') {
      <p>
        The email address associated with your State of Ohio OH|ID account does not match the email stored in the Department of Education’s records. This could be due to a recent change to your OH|ID email. Because of this mismatch, please take a few moments to verify and update your contact information.  Accurate and current contact information is necessary for you to receive important messages from the Department.
        <!--<br /><br />You can click on the “Skip Verification for Now” button at any step to immediately go to the application that you need to use. You will be asked to verify your contact information again the next time you log into a Department of Education application.-->
      </p>
    }
    @if (cService.tokenDtls.annualVerification=='True') {
      <p>
        At least once a year, the Department of Education needs to verify your contact information.  Accurate and current contact information is necessary for you to receive important messages from the Department.
        <!--<br /><br />You can click on the “Skip Verification for Now” button at any step to immediately go to the application that you need to use. You will be asked to verify your contact information again the next time you log into a Department of Education application.-->
      </p>
    }
  </div>
  <br /><br />
  <div class="container flex mobile">
    <span class="flex justify-center">
      <a href="{{cDataService.contactInfoLink}}" target="_blank">Click here for more information.</a>
    </span>
  </div>
  <div class="divider gray-500 mtb-20"></div>
  <div class="container flex mobile">
    <span class="basis-33">
      <span class="flex justify-center">
      </span>
    </span>
    <span class="basis-33">
      <span class="flex justify-center">
        <!--<button title="Skip Verification" id="" class="secondary border-red rounded-full hover-red hover-font-white flex-row-reverse mobile" (click)="cService.backtoapplication()">
        <div class="btn-txt font-red bold">Skip Verification for Now</div>
      </button>-->
    </span>
  </span>
  <span class="basis-33">
    <span class="flex justify-end">
      <button title="Next" class="rounded-full hover-blue-800 black mobile" (click)=updatestepcount(true)>
        <div class="btn-txt font-white bold">Next</div>
      </button>
    </span>
  </span>
</div>
</div>
